import { timelineNodes } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-foreground-950 border-b border-foreground-900">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="w-full">
          <div className="flex items-center gap-3">
            <span className="font-label text-xs tracking-[0.28em] text-accent-400">03</span>
            <span className="h-px flex-1 bg-foreground-800"></span>
            <span className="font-label text-xs tracking-[0.2em] text-foreground-400">TIMELINE</span>
          </div>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
            时间线还原：从聊天记录到公开动态，把节点按顺序归位
          </h2>
          <p className="mt-3 text-sm text-foreground-300 max-w-3xl leading-relaxed font-body">
            黑料图文内幕解析中最关键的一步，是把散落的线索放回同一条时间轴。以下六个节点按黑料图文深扒的时间顺序排列，
            每一层都能单独核对。
          </p>
        </div>

        <div className="relative mt-10 md:mt-12">
          <span className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 bg-foreground-800"></span>
          <span className="md:hidden absolute left-[11px] top-0 bottom-0 w-px bg-foreground-800"></span>

          <div className="space-y-6 md:space-y-0">
            {timelineNodes.map((node, i) => {
              const isRight = i % 2 === 1;
              return (
                <div key={node.id} className="relative pl-9 md:pl-0 md:grid md:grid-cols-2 md:gap-12 md:pb-8">
                  <span className="absolute left-[4px] md:left-1/2 top-1 md:top-2 w-4 h-4 -translate-x-0 md:-translate-x-1/2 rounded-full border-2 border-foreground-950 bg-accent-500 z-10"></span>

                  <div className={isRight ? 'md:col-start-2' : 'md:col-start-1 md:text-right'}>
                    <div className="rounded-lg border border-foreground-800 bg-foreground-900/70 p-4 md:p-5">
                      <span className="inline-flex items-center h-6 px-2.5 rounded-md bg-foreground-800 text-accent-400 text-[11px] font-label tracking-wide">
                        {node.stamp}
                      </span>
                      <h3 className={`mt-3 font-heading text-base md:text-lg font-semibold text-background-50 ${isRight ? '' : 'md:text-right'}`}>
                        {node.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-300 font-body">{node.text}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}